module.exports = __webpack_public_path__ + "static/media/banner-home.457d4c4f.jpg";